@for (field of aggs; track field) {
  <button mat-raised-button (click)="clearFilter(field)" class="filter-button">
    <div style="display: flex; align-items: center;">
      <div>{{field}}</div>
      <i class="material-icons">highlight_off</i>
    </div>
  </button>
}
